import log from '~/utils/log';
import { initMatomo, type MatomoTracker } from '@certible/use-matomo';

export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig();
    let isMatomoInitialized = false;
    let matomo: MatomoTracker | null = null;
    let hasMatomoConsent = false;
    const matomoConsent = useUsercentricsConsentItem('matomo');

    const trackCurrentView = () => {
        matomo?.trackPageView(window.location.href);
    };

    const initializeMatomo = () => {
        if (isMatomoInitialized || matomoConsent.value !== true) return;

        const matomoUrl = config.public.matomoUrl;
        const matomoID = config.public.matomoID;

        if (!matomoUrl || !matomoID) {
            log.warn('Matomo is not configured (matomoUrl/matomoID missing), skipping initialization');
            return;
        }

        const domains = config.public.matomoDomains
            ?.split(',')
            .map((domain) => domain.trim())
            .filter(Boolean);

        matomo = initMatomo({
            host: matomoUrl,
            siteId: matomoID,
            domains,
            enableLinkTracking: true,
            requireConsent: true,
            trackRouter: true,
            disableCookies: true,
            requireCookieConsent: false,
            enableHeartBeatTimer: true,
            heartBeatTimerInterval: 5
        });
        // requireConsent resets the consent flag based on remembered consent. Keep tracking
        // cookie-free by granting consent without allowing Matomo to remember it.
        matomo.push(['setConsentGiven', false]);
        isMatomoInitialized = true;
    };

    const applyConsent = () => {
        const hasConsent = matomoConsent.value === true;

        if (hasConsent) {
            if (isMatomoInitialized) {
                matomo?.push(['setConsentGiven', false]);
                if (!hasMatomoConsent) trackCurrentView();
            } else {
                initializeMatomo();
            }
        } else if (isMatomoInitialized && hasMatomoConsent) {
            matomo?.push(['forgetConsentGiven']);
        }

        hasMatomoConsent = hasConsent;
    };

    refreshUsercentricsConsentCache()
        .then(applyConsent)
        .catch((error) => {
            log.warn('Failed to refresh Usercentrics consent state', error);
        });
    onConsentUpdated(applyConsent);
});
